import { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { createContext } from 'use-context-selector';
import { getAccessTokenWithIntercept, getIdentityURLWithCodeChallengeWithIntercept } from "../../integrations/auth-pkce";
import { getHashParams, getByCookie } from "@frontend/shared-utility";
import {
  getAccessTokenFromStorage,
  logout,
  setAccessTokenInStorage,
} from "../../defaults/auth-control";
import { captureException } from "@frontend/feature-monitor";


export const AuthPkceContext = createContext({});

const AuthPkceProvider = ({ children }) => {

  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    (async () => {
      let authorizationCode;
      let codeVerifier;

      try {
        let accessToken = getAccessTokenFromStorage();
        authorizationCode = getHashParams(window.location.href).code;

        if (!accessToken && !authorizationCode) {
          window.location.href = await getIdentityURLWithCodeChallengeWithIntercept()
          return;
        }

        if (!accessToken) {
          codeVerifier = getByCookie('codeVerifier');

          if (!codeVerifier) {
            const missingVerifierError = new Error('[AuthPkce] codeVerifier ausente ao tentar /login/finish');
            missingVerifierError.extra = { hasCode: Boolean(authorizationCode), url: window.location.href };
            captureException(missingVerifierError);
          }

          accessToken = await getAccessTokenWithIntercept(authorizationCode, codeVerifier)
        }

        setAccessToken(accessToken);
        setAccessTokenInStorage(accessToken);
      } catch (error) {
        const enrichedError = new Error(`[AuthPkce] ${error.message || 'erro desconhecido'}`);
        enrichedError.originalError = error.code;
        enrichedError.extra = {
          hasCode: Boolean(authorizationCode),
          hasVerifier: Boolean(codeVerifier),
          url: window.location.href,
        };
        captureException(enrichedError);
        logout({ isAuthPkce: true });
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(() => ({
    accessToken,
    setAccessToken,
  }), [accessToken]);

  return (
    <AuthPkceContext.Provider value={value}>
      {children}
    </AuthPkceContext.Provider>
  )
}

AuthPkceProvider.propTypes = {
  children: PropTypes.element
};

export default AuthPkceProvider;
